import React from "react";
import { useTranslation } from "react-i18next";
import { CustomerStorageOptionButton } from "@components/CustomerStorage/components/CustomerStorageOptionButton/CustomerStorageOptionButton";
import { IconButton } from "@components/IconButton/IconButton";
import { CrossIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import type { IUseModalProps } from "@store/modal/modal";
import { type ICustomerStorageItem } from "@services/customerStorage/types";
import { type IFileOption } from "../CustomerStorageItemOptions/CustomerStorageItemOptions";

interface ICustomerStorageItemOptionsModalProps extends IUseModalProps {
  name: ICustomerStorageItem["name"];
  options?: IFileOption[];
}

export const CustomerStorageItemOptionsModal: React.FC<
  ICustomerStorageItemOptionsModalProps
> = ({ name, options, ...rest }) => {
  const modal = useModal(rest);

  const { t } = useTranslation();

  return (
    <Modal modal={modal} title={name} className="p-0 md:max-w-xl">
      <IconButton
        icon={CrossIcon}
        className="absolute right-4 top-4 m-[0.62rem] h-4 w-4 md:hidden"
        iconClassName="h-4 w-4"
        onClick={() => modal.close()}
        aria-label={t("action.close")}
      />
      <div className="flex w-full flex-col divide-y divide-grey-light border-t border-grey-light">
        {options?.map((option, index) => (
          <CustomerStorageOptionButton
            key={index}
            Icon={option.icon}
            onClick={async () => {
              await option.onClick();
              modal.close();
            }}
            iconClassName={option.iconClassName}
          >
            {option.label}
          </CustomerStorageOptionButton>
        ))}
      </div>
    </Modal>
  );
};
